module.exports = function (btsUi) {
    'use strict';
    btsUi.directive('btsLanguageBar', [function () {
        return {
            restrict: 'A',
            scope: {},
            template: require('./languageBar.html'),
            controller: 'footerController'
        };
    }]);
};